export enum USER_ROLE {
	ADMIN = 'ADMIN',
	USER = 'USER',
}

export enum USER_RIGHTS {}
